<main>
  <div class="container">
    <div class="columns">
      <div class="column is-10-tablet is-offset-1-tablet box-flat">
        <div class="background"></div>
        <div class="column is-10-tablet is-offset-1-tablet">
          <div class="columns">
            <div class="column" *ngIf="currentLanguage === 'de'">
              <lc-fancy-headline>Impressum</lc-fancy-headline>

              <p>Lean Corporation GmbH<br />
                Siebenbuergerstrasse 20<br />
                74343 Sachsenheim</p>

              <p>Handelsregister: HRB 767830<br />
                Registergericht: Registergericht Stuttgart</p>

              <p>Vertreten durch:
                Pedro Leao, Anja Leao</p>

              <h2>Kontakt</h2>
              <p>Telefon: +49 7147 2741603<br />
                E-Mail: info@lean-corporation.com</p>

              <h2>Umsatzsteuer-ID</h2>
              <p>Umsatzsteuer-Identifikationsnummer gem&auml;&szlig; &sect; 27 a Umsatzsteuergesetz:<br />
                DE321825178</p>

              <h2>EU-Streitschlichtung</h2>
              <p>Die Europ&auml;ische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a>.<br /> Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>

              <h2>Verbraucher&shy;streit&shy;beilegung/Universal&shy;schlichtungs&shy;stelle</h2>
              <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

              <h3>Konzeption, Gestaltung und Produktion</h3>
              <p>Timo Schüler / Agentur für Kommunikation | <a href="https://www.timoschueler.de/" target="_blank"
                                                               rel="noopener nofollow">www.timoschueler.de</a></p>
            </div>
            <div class="column" *ngIf="currentLanguage === 'en'">
              <lc-fancy-headline>Site Notice</lc-fancy-headline>

              <p>Lean Corporation GmbH<br />
                Siebenbuergerstrasse 20<br />
                74343 Sachsenheim</p>

              <p>Commercial Register: HRB 767830<br />
                Registration court: Registergericht Stuttgart</p>

              <p>Represented by: Pedro Leao, Anja Leao</p>

              <h2>Contact</h2>
              <p>Phone: +49 7147 2741603<br />
                E-mail: info@lean-corporation.com</p>

              <h2>VAT ID</h2>
              <p>Sales tax identification number according to Sect. 27 a of the Sales Tax Law:<br />
                DE321825178</p>

              <h2>EU dispute resolution</h2>
              <p>The European Commission provides a platform for online dispute resolution (ODR): <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr/</a>.<br /> Our e-mail address can be found above in the site notice.</p>

              <h2>Dispute resolution proceedings in front of a consumer arbitration board</h2>
              <p>We are not willing or obliged to participate in dispute resolution proceedings in front of a consumer arbitration board.</p>
              <h3>Conception, design and production</h3>
              <p>Timo Schüler / Agentur für Kommunikation | <a href="https://www.timoschueler.de/" target="_blank"
                                                               rel="noopener nofollow">www.timoschueler.de</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
